


















import EmailUtils, { Email } from '@/utils/EmailUtils';
import Vue from 'vue';
import { DataTableHeader } from 'vuetify';

export default Vue.extend({
  computed: {
    headers(): DataTableHeader<Email>[] {
      return [
        {
          text: this.$tc('email.key'),
          value: 'key',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },

  data: (): {
    items?: Email[];
  } => ({
    items: undefined,
  }),

  async mounted() {
    try {
      this.items = await EmailUtils.api.list();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  },

  methods: {
    async handleEdit(item: Email) {
      await this.$router.push({
        name: 'email-edit',
        params: { key: item.key.toString() },
      });
    },

    async handleCreate() {
      await this.$router.push({
        name: 'email-create',
      });
    },
  },
});
